import React from "react";

const SHOP_LOGO = "https://customer-assets.emergentagent.com/job_sri-paint-studio/artifacts/chy8ekpj_image.png";

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10 sm:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8">
          <div className="col-span-2">
            <img src={SHOP_LOGO} alt="Sri Pavanasutha Traders" className="h-12 sm:h-14 bg-white rounded-lg p-1 mb-4" />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Your trusted partner for premium paints, textures, and wall finishes. 
              Transforming spaces across Godavarikhani since 2017.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm sm:text-base mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#home" className="hover:text-purple-400 transition-colors">Home</a></li>
              <li><a href="#products" className="hover:text-purple-400 transition-colors">Products</a></li>
              <li><a href="#solutions" className="hover:text-purple-400 transition-colors">Solutions</a></li>
              <li><a href="#contact" className="hover:text-purple-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm sm:text-base mb-3 sm:mb-4">Products</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Royal Play Designs</li>
              <li>Texture Paints</li>
              <li>Wallpapers</li>
              <li>Floor Paints</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-gray-500 text-xs sm:text-sm">
            © 2024 Sri Pavanasutha Traders. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs sm:text-sm">
            Made with <span className="text-red-500">❤</span> in Godavarikhani
          </p>
        </div>
      </div>
    </footer>
  );
};
